'use client';

import { cn, Collapsible, CollapsibleContent, CollapsibleTrigger } from '@newfront-insurance/core-ui/v2';
import { ChevronDownIcon } from 'lucide-react';
import type { ComponentProps } from 'react';

export type SourcesProps = ComponentProps<'div'>;

export function Sources({ className, ...props }: SourcesProps) {
  return <Collapsible className={cn('not-prose text-primary mb-4 text-xs', className)} {...props} />;
}

export type SourcesTriggerProps = ComponentProps<typeof CollapsibleTrigger> & {
  count: number;
};

export function SourcesTrigger({ className, count, children, ...props }: SourcesTriggerProps) {
  return (
    <CollapsibleTrigger className={cn('flex items-center gap-2', className)} {...props}>
      {children ?? (
        <>
          <p className="font-medium">Used {count} sources</p>
          <ChevronDownIcon className="h-4 w-4 rotate-180 transition-transform [[data-state=open]>&]:rotate-0" />
        </>
      )}
    </CollapsibleTrigger>
  );
}

export type SourcesContentProps = ComponentProps<typeof CollapsibleContent>;

export function SourcesContent({ className, ...props }: SourcesContentProps) {
  return (
    <CollapsibleContent
      className={cn(
        'mt-3 flex w-fit flex-col gap-2',
        'data-[state=closed]:fade-out-0 data-[state=closed]:slide-out-to-top-2 data-[state=open]:slide-in-from-top-2 data-[state=closed]:animate-out data-[state=open]:animate-in outline-none',
        className,
      )}
      {...props}
    />
  );
}
